import React, { PureComponent } from 'react';
import Helmet from 'react-helmet';
import SpendingsStore from '../../stores/SpendingsStore';
import SpendingsActionCreator from '../../actions/SpendingsActionCreator';
import AnalyticsActionCreator from '../../actions/AnalyticsActionCreator';
import SpendingsLandingScreen from './SpendingsLandingScreen';
import SpendingsLandingScreenMobile from './SpendingsLandingScreenMobile';
import NoSpendDataError from './NoSpendDataError';
import { RequiresAuthenticatedUser } from '../RequiresAuthenticatedUser';
import BrowserUtils from '../../utils/BrowserUtils';
import AnyQuestions from '../help/AnyQuestions';
import OrientationSwitch from '../common/OrientationSwitch';
import LoaderComponent from '../common/LoaderComponent';

const getStateFromStores = () => ({
  accountsList: SpendingsStore.getAll(),
  getBudgetPreferencesData: SpendingsStore.getBudgetPreferencesConnectionData(),
  hasBudgetPreferencesError: SpendingsStore.hasBudgetPreferencesError(),
  currentAccFlag: SpendingsStore.getCurrentAccountFlag(),
  getAllAccountIds: SpendingsStore.updatedAccountIds(),
  transactionsTagName: SpendingsStore.transactionsTagName(),
  isError: SpendingsStore.isError(),
  statusResponse: SpendingsStore.getStatusResponse(),
  isAccountModal: SpendingsStore.isAccountModal(),
  isBudgetSuccess: SpendingsStore.isBudgetSuccess(),
  spendingPageToLoad: SpendingsStore.spendingPageToLoad(),
  isLoadPage: SpendingsStore.isLoadPage(),
  isCreateBudgetPage: SpendingsStore.isCreateBudgetPage(),
  isEarningPage: SpendingsStore.isEarningPage(),
  isTransactionPage: SpendingsStore.isTransactionPage(),
  transactionPageSize: SpendingsStore.transactionPageSize(),
  isNetworkError: SpendingsStore.isNetworkError(),
  isInternalServerError: SpendingsStore.isInternalServerError(),
  screenFlagForMobile: SpendingsStore.checkScreenFlag(),
});

class SpendingsPage extends PureComponent {
  state = {
    storeChanged: false,
    faqFlag: false,
    ...getStateFromStores(),
  };

  componentDidMount() {
    BrowserUtils.setViewPort(1);
    this.loadSpendingAction();
    document.body.style.backgroundColor = 'white';
    SpendingsStore.addChangeListener(this.onStoreChange);
    // Record an analytics user event.
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/view',
        action: 'Appeared',
      },
      {
        description: 'PageLoaded',
      }
    );
  }

  componentWillUnmount() {
    document.body.style.backgroundColor = '';
    SpendingsActionCreator.checkScreenFlag(0);
    SpendingsStore.removeChangeListener(this.onStoreChange);
  }

  loadSpendingAction = () => {
    SpendingsActionCreator.getAccountsList();
    SpendingsActionCreator.getBudgetConnection();
    SpendingsActionCreator.getTagListConnection();
    SpendingsActionCreator.getBudgetPreferencesConnection();
  };

  onStoreChange = () => {
    this.setState({ storeChanged: true, ...getStateFromStores() });
  };

  reload = () => {
    this.setState({ internalServerError: false });
    this.loadSpendingAction();
  };

  closeFaq = () => {
    this.setState({ faqFlag: false });
  };

  openFaq = () => {
    this.setState({ faqFlag: true });
  };

  switchSpendingView = () => {
    const { content } = this.props;
    const {
      accountsList,
      screenFlagForMobile,
      getBudgetPreferencesData,
      isCreateBudgetPage,
      getAllAccountIds,
      currentAccFlag,
      transactionsTagName,
      isTransactionPage,
      isAccountModal,
      isBudgetSuccess,
      isEarningPage,
      spendingPageToLoad,
      transactionPageSize,
      hasBudgetPreferencesError,
    } = this.state;

    if (BrowserUtils.isMobileView()) {
      return (
        <SpendingsLandingScreenMobile
          {...this.props}
          spendingAccountList={accountsList.accounts}
          content={content}
          loadSpendingPage={spendingPageToLoad}
          earnings={getBudgetPreferencesData}
          earningsError={hasBudgetPreferencesError}
          isCreateBudgetPage={isCreateBudgetPage}
          isTransactionPage={isTransactionPage}
          hasBudgetData={isBudgetSuccess}
          isEarningPage={isEarningPage}
          showAccountModal={isAccountModal}
          getAllAccountIds={getAllAccountIds}
          transactionsTagName={transactionsTagName}
          transactionPageSize={transactionPageSize}
          openFaq={this.openFaq}
          currentAccFlag={currentAccFlag}
          screenFlagForMobile={screenFlagForMobile}
        />
      );
    }
    return (
      <SpendingsLandingScreen
        {...this.props}
        spendingAccountList={accountsList.accounts}
        content={content}
        loadSpendingPage={spendingPageToLoad}
        earnings={getBudgetPreferencesData}
        earningsError={hasBudgetPreferencesError}
        isCreateBudgetPage={isCreateBudgetPage}
        isTransactionPage={isTransactionPage}
        hasBudgetData={isBudgetSuccess}
        isEarningPage={isEarningPage}
        showAccountModal={isAccountModal}
        getAllAccountIds={getAllAccountIds}
        currentAccFlag={currentAccFlag}
        transactionsTagName={transactionsTagName}
        transactionPageSize={transactionPageSize}
        openFaq={this.openFaq}
      />
    );
  };

  renderSpendingsPage = () => {
    const { content } = this.props;
    const {
      faqFlag,
      statusResponse,
      isLoadPage,
      isError,
      storeChanged,
      isNetworkError,
      isInternalServerError,
    } = this.state;
    if (!storeChanged || !isLoadPage) {
      return (
        <div className="main-container">
          <LoaderComponent type="large" />
        </div>
      );
    }
    if (isError || isNetworkError || isInternalServerError) {
      return (
        <NoSpendDataError
          content={content}
          statusResponse={statusResponse}
          reload={this.reload}
        />
      );
    }
    if (faqFlag) {
      return <AnyQuestions {...this.props} closed={this.closeFaq} />;
    }
    return (
      <div className="b container-fluid-full dashboard">
        <Helmet title="Spending" />
        {this.switchSpendingView()}
      </div>
    );
  };

  render() {
    return <OrientationSwitch view={this.renderSpendingsPage} />;
  }
}

export default RequiresAuthenticatedUser(SpendingsPage);
